module.exports = __webpack_public_path__ + "img/bride-2.b59113c7.jpg";